import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import request from '../../utils/request';
import getElementNode from './json2tree';
import DataTree from './DataTree';
import { Typography } from '@material-ui/core';
/**
 * @extends {React.Component<import('./types').DataTreeContainerProps>}
 */

export var DataTreeContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataTreeContainer, _React$Component);

  function DataTreeContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataTreeContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataTreeContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      tree: {},
      hasError: false,
      isLoading: false
    };

    _this.fetchData = function () {
      var _this$props = _this.props,
          workspace = _this$props.workspace,
          path = _this$props.path;

      if (path) {
        _this.setState({
          isLoading: true,
          hasError: false
        });

        request({
          url: "/backend/outputelement?workspace=".concat(encodeURIComponent(workspace), "&filepath=").concat(encodeURIComponent(path))
        }).then(_this.loadFileTree, _this.onDataError);
      }
    };

    _this.loadFileTree = function (schema) {
      var tree = getElementNode(schema);

      _this.setState({
        tree: tree,
        isLoading: false
      });
    };

    _this.onDataError = function () {
      _this.setState({
        hasError: true,
        isLoading: false
      });
    };

    return _this;
  }

  _createClass(DataTreeContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.path !== prevProps.path) this.fetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          hasError = _this$state.hasError,
          tree = _this$state.tree;
      if (isLoading) return 'Loading...';
      if (hasError) return React.createElement(Typography, {
        color: "error"
      }, "Could not load the data model, the file is missing or invalid.");

      var _this$props2 = this.props,
          workspace = _this$props2.workspace,
          path = _this$props2.path,
          rest = _objectWithoutProperties(_this$props2, ["workspace", "path"]);

      return React.createElement(DataTree, Object.assign({
        tree: tree
      }, rest));
    }
  }]);

  return DataTreeContainer;
}(React.Component);
export default DataTreeContainer;